module.exports = __webpack_public_path__ + "2753bd91db908bc866b3458c931857f6.svg";